module.exports = __webpack_public_path__ + "static/img/74ff9d4c076451e7c1ecd017a9c852b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fw_wztq.png
// module id = kbX2
// module chunks = 1